import {
	Component,
	Output,
	EventEmitter,
	Input,
	ChangeDetectionStrategy,
} from '@angular/core';
import { MatterDispatch } from '@state/matter';
import { MatterFields } from '@models/matter';
import { Store } from '@ngxs/store';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { tap } from 'rxjs/operators';
import { TestHooks } from './occupancy-date.hooks';

@Component({
	selector: 'app-occupancy-date',
	templateUrl: './occupancy-date.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class OccupancyDateComponent {
	testHooks = TestHooks;
	@Input() skeletonLoading: boolean;
	@Output() onFocus = new EventEmitter<string>();
	private closingDate: string;
	private occupancyDate: string;
	public occupancyDate$ = this.store.select(SelectedMatter.occupancyDate).pipe(
		tap((date) => {
			this.occupancyDate = date;
		}),
	);

	public closingDate$ = this.store.select(SelectedMatter.closingDate).pipe(
		tap((date) => {
			this.closingDate = date;
		}),
	);
	public field = MatterFields.TITLE_SEARCH_COMPLETION_DATE;

	constructor(
		private matterDispatch: MatterDispatch,
		private store: Store,
	) {}

	_onFocus() {
		this.onFocus.emit(this.field);
	}

	onChange = (event: string) => {
		if (
			event !== this.occupancyDate &&
			(!event || !this.closingDate || this.closingDate >= event)
		) {
			this.matterDispatch.OverwriteFields('occupancyDate', event);
		}
	};
}
